import {
  ConsolidatedContact,
  ContactStatusChangeInput,
} from '../../../api/CoachingNotes/schema';
import { FormDetailsInput } from '../../../api/FormLibrary/schema';
import _ from 'lodash';

/**
 * @param contactInput
 * @param isCRO
 * @returns FormDetailsInput
 *
 * Purpose: In terms of NO UI/UX change for CRO and legacy form and we want to seamlessly support form
 * library, we are using a new API to update the form review. In the frontend side, we will continue
 * filling contactDetailsInput to keep the flow backward compatible. However, we will introdue a new field
 * to test form library feature in the transition phase. Therefore, we are using a local form template to
 * backup the review infomation in new format.
 */
export function genericFormParser(
  contactInput: ContactStatusChangeInput,
  contact?: ConsolidatedContact
): FormDetailsInput {
  // Temporary Fix
  let formDetails;
  if (contact?.formReviews) {
    contact.formReviews.forEach(review => {
      formDetails = {
        formID: review.formID,
        version: review.version,
        contactStatus: contactInput.contactStatus!,
        formAnswers: review.formAnswer,
      };
    });
  }

  if (formDetails === undefined) {
    throw new Error(
      `Unable to retrieve contact formReviews ${JSON.stringify(contact)}`
    );
  }

  return formDetails;
}
